export default "__VITE_ASSET__1d5edf68__"